import SHA256 from 'crypto-js/sha256';

const stableStringify = (value: unknown): string => {
  if (value === null || typeof value !== 'object') {
    return JSON.stringify(value);
  }

  if (Array.isArray(value)) {
    return `[${value.map((item) => stableStringify(item)).join(',')}]`;
  }

  const objectValue = value as Record<string, unknown>;
  const keys = Object.keys(objectValue).sort();
  const serializedEntries = keys.map((key) => `${JSON.stringify(key)}:${stableStringify(objectValue[key])}`);

  return `{${serializedEntries.join(',')}}`;
};

const sha256Hex = (input: string): string => SHA256(input).toString();

export const stableSha256FromValue = (value: unknown): string => sha256Hex(stableStringify(value));
